<template>
  <div>
    <div
      style="display: flex; flex-direction: column"
      id="main"
      v-show="canShowMainComponent"
    >
      <AppHeader />
      <div id="app" class="">
        <router-view :key="$route.path" />
        <notifications
          group="global"
          :ignoreDuplicates="true"
          animation-type="velocity"
          :animation="animation"
        />
        <notifications
          group="globalError"
          :ignoreDuplicates="true"
          animation-type="velocity"
          :animation="animation"
        />
        <notifications
          group="bopNotificationGroup"
          :ignoreDuplicates="true"
          animation-type="velocity"
          :animation="animation"
        />
      </div>
    </div>
    <div
      v-if="!canShowMainComponent"
      class="d-flex justify-content-center mb-3 height-100vh"
    >
      <b-spinner label="Loading..." class="margin-auto"></b-spinner>
    </div>
  </div>
</template>

<script lang="ts">
import AppHeader from "@/components/Global/AppHeader.vue";
import { Component,Vue } from "vue-property-decorator";

@Component({
  components: {
    AppHeader,
  },
})
export default class App extends Vue {
  private animation!: any;
  private showApp: boolean = false;
  private get isTranslationLoaded(): boolean {
    return this.$store.state.isTranslatinLoaded;
  }

  private get canShowMainComponent(): boolean {
    return this.isTranslationLoaded;
  }
  private beforeCreate() {
    window.addEventListener("beforeunload", this.confirmPageLeaving);
    this.animation = {
      enter(element) {
        let height = -element.clientHeight;

        return {
          translateY: [0, height],
          opacity: [1, 0],
        };
      },
      leave: {
        translateY: 0,
        opacity: 0,
      },
    };
  }
  private async confirmPageLeaving() {
    this.$store.commit("changeHasBeenModified", false);
  }

  private mounted() {
    // Fix mobile viewport height
    const appHeight = () => {
      const doc = document.documentElement;
      doc.style.setProperty("--app-height", `${window.innerHeight}px`);
    };
    window.addEventListener("resize", appHeight);
    appHeight();
  }
  errorCaptured(err, vm, info) {
    console.log(err);
    console.log(info);
    console.log(vm);
  }
}
</script>

<style lang="scss">
@import "./styles/_feb.scss";

:root {
  --app-height: 100%;
}
html,
body,
#main {
  overflow: hidden;
  height: 100vh;
  @media not all and (hover: hover) {
    height: var(--app-height);
  }
}
#app {
  overflow: auto;
  height: auto;
}
.height-100vh {
  height: 100vh;
}
.margin-auto {
  margin: auto;
}

[v-cloak] {
  display: none;
}
</style>
